const Mock = require('mockjs');

const fileDownloadList = [
    {
        id: 1,
        name: '亚洲知识产权营商论坛报名回执.doc (2019/11/8)',
        src: 'http://copyright.gzcc315.com/images/20191108165759363249.doc',
    },
    {
        id: 2,
        name: '关于推荐2019年度广东省版权兴业示范基地的通知.pdf  (2019/9/9)',
        src: 'http://copyright.gzcc315.com/images/20190909174138797257.pdf',
    },
    {
        id: 3,
        name: '关于推荐2019年度广东省最具价值版权作品的通知.pdf  (2019/9/9)',
        src: 'http://copyright.gzcc315.com/images/20190909174138797257.pdf',
    },
    {
        id: 4,
        name: '申请人用户使用手册.pdf  (2019/8/5)',
        src: 'http://copyright.gzcc315.com/images/20190805165749538995.pdf',
    },
    {
        id: 5,
        name: '职务创作著作权确认书.doc  (2019/7/24)',
        src: 'http://copyright.gzcc315.com/images/20190724104053756774.doc',
    },
    {
        id: 6,
        name: '版权登记系统用户注册确认书.doc  (2019/7/24)',
        src: 'http://copyright.gzcc315.com/images/20190724103814834885.doc',
    },
    {
        id: 7,
        name: '广州市作品著作权登记政府资助申请作品付费发票清单.xls  (2019/7/23)',
        src: 'http://copyright.gzcc315.com/images/20190723162411803800.xls',
    },
    {
        id: 8,
        name: '广州市作品著作权登记政府资助申请作品材料清单.xls  (2019/7/23)',
        src: 'http://copyright.gzcc315.com/images/20190723162402272588.xls',
    },
    {
        id: 9,
        name: '广州市作品著作权登记政府资助申请表（wps版本）.doc  (2019/7/23)',
        src: 'http://copyright.gzcc315.com/images/20190723162350647414.doc',
    },
    {
        id: 10,
        name: '广州市作品著作权登记政府资助申请表（word版本）.doc  (2019/7/23)',
        src: 'http://copyright.gzcc315.com/images/20190723162338741847.doc',
    },
    {
        id: 11,
        name: '广东省版权保护联合会美术和艺术设计专业委员会入会申请表.doc  (2019/7/23)',
        src: 'http://copyright.gzcc315.com/images/20190723160702959665.doc',
    },
    {
        id: 12,
        name: '广东省版权保护联合会入会登记表.doc  (2019/4/23)',
        src: 'http://copyright.gzcc315.com/images/20190423113825761986.doc',
    },
    {
        id: 13,
        name: '资助申请表（软件）.doc  (2015/7/28)',
        src: 'http://copyright.gzcc315.com/images/20150728170958025340.doc',
    },
    {
        id: 14,
        name: '计算机软件著作权登记指南.pdf  (2014/9/18)',
        src: 'http://copyright.gzcc315.com/images/20140918170630823399.pdf',
    },
    {
        id: 15,
        name: '软件著作权登记非职务开发证明.doc  (2014/7/3)',
        src: 'http://copyright.gzcc315.com/images/20140703163402964104.doc',
    },
];
// 文件下载
Mock.mock('http://copyright.gzcc315.com/fileDownload', 'get', options => {
	let pageNum = JSON.parse(options.body).pageNum;
	let start = (pageNum * 12) - 12;
    let end = pageNum * 12;
    end = end > fileDownloadList.length ? fileDownloadList.length : end;
    let pageData = [];
    for(var i = start; i < end; i++) {
        pageData.push(fileDownloadList[i])
	}
    return {
        pageData: pageData,
        total: fileDownloadList.length
    }
})